import styled from 'styled-components';

import {Button} from 'components/ui-kit/Button';

import {colors, font} from 'theme';

export const Content = styled.div`
    padding: 0 2px 2px;
`;

export const InfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const WarningCard = styled.div`
    background: #fff4e6;
    border: 1px solid #ffa726;
    border-radius: 8px;
    padding: 12px;
`;

export const WarningTitle = styled.div`
    color: ${colors.darkGrey};
    font-family: ${font.family.primary};
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    margin-bottom: 4px;
`;

export const WarningDescription = styled.div`
    color: ${colors.textPrimary};
    font-family: ${font.family.primary};
    font-size: 12px;
    line-height: 16px;
`;

export const Question = styled.div`
    color: ${colors.darkGrey};
    font-family: ${font.family.primary};
    font-size: 14px;
    line-height: 20px;
`;

export const GtinAccent = styled.span`
    color: ${colors.brandPrimary};
    font-weight: 600;
`;

export const DeletedDataTitle = styled.div`
    color: ${colors.textPrimary};
    font-family: ${font.family.primary};
    font-size: 14px;
    line-height: 20px;
`;

export const DeletedDataList = styled.ul`
    margin: 0;
    padding-left: 0;
    list-style: none;
`;

export const DeletedDataItem = styled.li`
    color: ${colors.textPrimary};
    font-family: ${font.family.primary};
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 4px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const Footer = styled.div`
    border-top: 1px solid ${colors.border};
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding-top: 20px;
    margin-top: 20px;

    & > * {
        width: fit-content;
    }
`;

export const DeleteButton = styled(Button)`
    background-color: #ff5252;
    border-color: #ff5252;
    color: ${colors.white};

    &:disabled {
        background-color: ${colors.textMuted};
        border-color: ${colors.textMuted};
        color: ${colors.white};
    }

    &:not(:disabled):hover,
    &:not(:disabled):focus-visible {
        background-color: ${colors.danger};
        border-color: ${colors.danger};
        color: ${colors.white};
    }
`;
